import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'form',
  ]

  declare readonly formTarget: HTMLFormElement

  connect () {
    this.formTarget.submit()
  }
}
